<div class="card bg-transparent border rounded-5 shadow-sm d-none d-xl-block mb-3">
    <a class="text-decoration-none">
      <h6 class="card-header text-muted bg-transparent">Our Work</h6>
    </a>

    <div class="px-3 py-3">
      <a :href="dashboard_path" class="text-decoration-none text-dark">
        <div class="document-item d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center flex-grow-1">
            <div class="file-icon-box d-flex align-items-center justify-content-center text-white me-3 bg-primary">
              <i class="bi bi-bar-chart-fill"></i>
            </div>
            <div>
              <span class="mb-0 document-name text-xs">DSD overview</span>
            </div>
          </div>
          <i class="bi bi-arrow-right text-muted fs-5"></i>
        </div>
      </a>
    </div>
  </div>